"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColors = exports.LayerType = exports.StretchingType = exports.VerticalAlignmentType = exports.HorizontalAlignmentType = void 0;
var HorizontalAlignmentType;
(function (HorizontalAlignmentType) {
    HorizontalAlignmentType["LEFT"] = "left";
    HorizontalAlignmentType["RIGHT"] = "right";
    HorizontalAlignmentType["CENTER"] = "center";
})(HorizontalAlignmentType = exports.HorizontalAlignmentType || (exports.HorizontalAlignmentType = {}));
var VerticalAlignmentType;
(function (VerticalAlignmentType) {
    VerticalAlignmentType["TOP"] = "top";
    VerticalAlignmentType["CENTER"] = "center";
    VerticalAlignmentType["BOTTOM"] = "bottom";
})(VerticalAlignmentType = exports.VerticalAlignmentType || (exports.VerticalAlignmentType = {}));
var StretchingType;
(function (StretchingType) {
    StretchingType["FILL"] = "fill";
    StretchingType["CENTER"] = "center";
    StretchingType["COVER"] = "cover";
})(StretchingType = exports.StretchingType || (exports.StretchingType = {}));
var LayerType;
(function (LayerType) {
    LayerType["TEXT"] = "text";
    LayerType["IMAGE"] = "image";
})(LayerType = exports.LayerType || (exports.LayerType = {}));
var TextColors;
(function (TextColors) {
    TextColors["_000000"] = "#000000";
    TextColors["_191939"] = "#191939";
    TextColors["_FFFFFF"] = "#FFFFFF";
    TextColors["_494A4C"] = "#494A4C";
    TextColors["_D6A758"] = "#D6A758";
    TextColors["_153D68"] = "#153D68";
})(TextColors = exports.TextColors || (exports.TextColors = {}));
